// Candy card game data - ranked by popularity and sales
export const CANDY_CARDS = [
  { id: 1, name: "M&M's", rank: 1, image: "/images/candy/candy_1.jpg" },
  { id: 2, name: "Reese's Peanut Butter Cups", rank: 2, image: "/images/candy/candy_2.jpg" },
  { id: 3, name: "Snickers", rank: 3, image: "/images/candy/candy_3.jpg" },
  { id: 4, name: "Kit Kat", rank: 4, image: "/images/candy/candy_4.jpg" },
  { id: 5, name: "Twix", rank: 5, image: "/images/candy/candy_5.jpg" },
  { id: 6, name: "Skittles", rank: 6, image: "/images/candy/candy_6.jpg" },
  { id: 7, name: "Hershey's Milk Chocolate", rank: 7, image: "/images/candy/candy_7.jpg" },
  { id: 8, name: "Starburst", rank: 8, image: "/images/candy/candy_8.jpg" },
  { id: 9, name: "Milky Way", rank: 9, image: "/images/candy/candy_9.jpg" },
  { id: 10, name: "3 Musketeers", rank: 10, image: "/images/candy/candy_10.jpg" },
  { id: 11, name: "Butterfinger", rank: 11, image: "/images/candy/candy_11.jpg" },
  { id: 12, name: "Sour Patch Kids", rank: 12, image: "/images/candy/candy_12.jpg" },
  { id: 13, name: "Jolly Ranchers", rank: 13, image: "/images/candy/candy_13.jpg" },
  { id: 14, name: "Twizzlers", rank: 14, image: "/images/candy/candy_14.jpg" },
  { id: 15, name: "Nerds", rank: 15, image: "/images/candy/candy_15.jpg" },
  { id: 16, name: "Swedish Fish", rank: 16, image: "/images/candy/candy_16.jpg" },
  { id: 17, name: "Almond Joy", rank: 17, image: "/images/candy/candy_17.jpg" },
  { id: 18, name: "Baby Ruth", rank: 18, image: "/images/candy/candy_18.jpg" },
  { id: 19, name: "100 Grand", rank: 19, image: "/images/candy/candy_19.jpg" },
  { id: 20, name: "PayDay", rank: 20, image: "/images/candy/candy_20.jpg" },
  { id: 21, name: "Whoppers", rank: 21, image: "/images/candy/candy_21.jpg" },
  { id: 22, name: "Milk Duds", rank: 22, image: "/images/candy/candy_22.jpg" },
  { id: 23, name: "Junior Mints", rank: 23, image: "/images/candy/candy_23.jpg" },
  { id: 24, name: "York Peppermint Patty", rank: 24, image: "/images/candy/candy_24.jpg" },
  { id: 25, name: "Airheads", rank: 25, image: "/images/candy/candy_25.jpg" },
  { id: 26, name: "Laffy Taffy", rank: 26, image: "/images/candy/candy_26.jpg" },
  { id: 27, name: "Tootsie Roll", rank: 27, image: "/images/candy/candy_27.jpg" },
  { id: 28, name: "Dubble Bubble", rank: 28, image: "/images/candy/candy_28.jpg" },
  { id: 29, name: "Smarties", rank: 29, image: "/images/candy/candy_29.jpg" },
  { id: 30, name: "Candy Corn", rank: 30, image: "/images/candy/candy_30.jpg" }
];
